<template>
    <div id="itemChooser">
        <input
            type="text"
            placeholder="Cari soal ..."
            class="form-control"
            @click="showModal = true"
        />

        <transition name="modal" v-if="showModal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div id="modal" class="modal-container">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-4">
                                    <label>Bab:</label>
                                    <select
                                        name=""
                                        id=""
                                        class="form-control"
                                        v-model="chapterIndex"
                                    >
                                        <option value="" disabled>
                                            -- PILIH BAB --
                                        </option>
                                        <option
                                            :value="index"
                                            v-bind:key="index"
                                            v-for="(chapter, index) in topics"
                                        >
                                            {{ chapter.nama }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-4" v-if="chapterIndex">
                                    <label>Sub Bab (Optional):</label>
                                    <select
                                        name=""
                                        id=""
                                        class="form-control"
                                        v-model="subChapterIndex"
                                    >
                                        <option value="">
                                            -- PILIH SUB BAB --
                                        </option>
                                        <option
                                            :value="index"
                                            v-bind:key="index"
                                            v-for="(sub, index) in topics[
                                                chapterIndex
                                            ].subs"
                                        >
                                            {{ sub.nama }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="row m-t-10">
                                <div class="col-md-12">
                                    <button
                                        type="button"
                                        class="btn btn-success btn-block"
                                        @click="search()"
                                    >
                                        Cari
                                    </button>
                                </div>
                            </div>
                            <div class="row m-t-10" v-if="items.length > 0">
                                <app-datatable
                                    :items="items"
                                    :headers="headers"
                                    :has-custom-search="true"
                                    v-on:doSearch="
                                        searchFilter = {
                                            query: $event.value,
                                            by: headersKey[$event.key],
                                        }
                                    "
                                    v-on:selected="selectedItem = $event"
                                    v-on:dblClicked="confirmSelectedItem()"
                                ></app-datatable>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-danger"
                                @click="showModal = false"
                            >
                                Tutup
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import DataTable from "@/components/plugins/DataTable";
import ItembankService from "@/services/itembank.js";

export default {
    name: "app-itemchooser",

    props: ["subject"],

    components: {
        "app-datatable": DataTable,
    },

    data: function () {
        return {
            headers: [
                "Kode Soal",
                "Bab",
                "Sub Bab",
                "Sub Sub Bab",
                "eigen",
                "label",
            ],
            headersKey: [
                "item_code",
                "bab",
                "subbab",
                "subsubbab",
                "",
                "label",
            ],
            showModal: false,
            chapterIndex: "",
            subChapterIndex: "",
            searchFilter: null,
            topics: [],
            items: [],
            selectedItem: null,
        };
    },

    watch: {
        subject: function (val) {
            this.topics = [];
            this.loadTopicData();
        },
        searchFilter() {
            this.doFilter();
        },
    },

    methods: {
        loadTopicData: function () {
            var context = this;
            ItembankService.getListOfTopic(
                this.subject.code,
                function (result) {
                    if (result.success) {
                        result.data.forEach(function (topic) {
                            context.topics.push(topic);
                        });
                    }
                },
            );
        },

        search: function () {
            this.items.splice(0, this.items.length);
            var itemCode = this.getItemCode();
            var context = this;
            ItembankService.searchItemByItemCode(itemCode, function (result) {
                if (result.success) {
                    result.data.forEach(function (item) {
                        var subChapter = "-";
                        var subSubChapter = "-";

                        if (item.sub_bab != null)
                            subChapter = item.sub_bab.nama;
                        if (item.sub_sub_bab != null)
                            subSubChapter = item.sub_sub_bab.nama;

                        var row = {
                            id: item.id,
                            data: [
                                item.kode,
                                item.bab.nama,
                                subChapter,
                                subSubChapter,
                                item.nilai_eigen,
                                item.label,
                            ],
                        };
                        context.items.push(row);
                    });
                }
            });
        },

        doFilter: function () {
            var context = this;
            var search = this.searchFilter;
            var newItems = [];

            if (search.query == null) {
                this.search();
            } else {
                ItembankService.searchItemByFilter(search, function (result) {
                    if (result.success) {
                        result.data.forEach(function (item) {
                            var subChapter = "-";
                            var subSubChapter = "-";

                            if (item.sub_bab != null)
                                subChapter = item.sub_bab.nama;
                            if (item.sub_sub_bab != null)
                                subSubChapter = item.sub_sub_bab.nama;

                            var row = {
                                id: item.id,
                                data: [
                                    item.kode,
                                    item.bab.nama,
                                    subChapter,
                                    subSubChapter,
                                    item.nilai_eigen,
                                    item.label,
                                ],
                            };
                            newItems.push(row);
                        });
                    }
                });
                this.items = newItems;
            }
        },

        getItemCode: function () {
            var chapter = null;
            var subChapter = null;

            var itemCode = "";
            switch (this.$store.state.tryout.level) {
                case "SMA":
                    itemCode += "3";
                    break;
                case "SMP":
                    itemCode += "2";
                    break;
                case "SD":
                    itemCode += "1";
                    break;
                default:
                    itemCode += "3";
            }

            switch (this.$store.state.tryout.type) {
                case "SBMPTN":
                    itemCode += "1";
                    break;
                case "UJIAN_AKHIR_NASIONAL":
                    itemCode += "2";
                    break;
                case "UJIAN_AKHIR_SEKOLAH":
                    itemCode += "3";
                    break;
                default:
                    itemCode += "4";
            }

            itemCode += this.subject.code;
            chapter = this.topics[this.chapterIndex];
            itemCode += chapter.kode;

            subChapter = null;
            if (this.subChapterIndex != "") {
                subChapter = chapter.subs[this.subChapterIndex];
                itemCode += subChapter.kode;
            }

            return itemCode;
        },

        confirmSelectedItem: function () {
            this.showModal = false;
            this.$emit("selected", this.selectedItem);
        },
    },

    mounted: function () {
        this.loadTopicData();
    },
};
</script>



// WEBPACK FOOTER //
// ItemChooser.vue?ed2d5184